import React, { useState, useEffect } from 'react';
import _ from 'lodash'
import { FormattedMessage } from 'react-intl';

import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { REPORT_LANGUAGE } from '../../i18n';

import { KeyboardArrowDownOutlinedIcon } from '../../constants/images';

import { CustomFormLabel } from '../customComponent';

import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';


const LANGUAGE = [
  {
    id: 'common.language.zh',
    value: 'CHINESE',
  },
  {
    id: 'common.language.en',
    value: 'ENGLISH',
  },
  {
    id: 'common.language.ja',
    value: 'JAPANESE',
  },
]

const BasicDataLanguage = (props) => {
  const {
    media,
    reportLanguage,
    setReportLanguage,
    setCurrentSheetName,
    setCurrentSheetOrigiName,
    setSelectedExcelIndex,
  } = props;

  const { currentActiveData, locale, entryPath } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();


  useEffect(() => {
    if (entryPath.includes('edit')) return;

    if (locale.includes("en")) {
      setReportLanguage(REPORT_LANGUAGE.en);
    } else if (locale.includes("ja")) {
      setReportLanguage(REPORT_LANGUAGE.ja);
    } else {
      setReportLanguage(REPORT_LANGUAGE.zh);
    }
  }, [locale])

  useEffect(() => {
    if (media === 'GOOGLE') {
      setCurrentSheetName("");
      setCurrentSheetOrigiName("");
      setSelectedExcelIndex(null);
    }
  }, [reportLanguage])

  return (
    <Box mb={2}>
      <CustomFormLabel>
        <FormattedMessage id="createData.basic.language" /><span>*</span>
      </CustomFormLabel>
      <Select
        value={reportLanguage}
        IconComponent={KeyboardArrowDownOutlinedIcon}
        onChange={(e) => {
          setReportLanguage(e.target.value)
        }}
        sx={{
          width: '22%',
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: mainColor
          }
        }}
      >
        {LANGUAGE.map((el) => (
          <MenuItem
            key={el.id}
            value={el.value}
            sx={{ "&.Mui-selected": { backgroundColor: w01Color } }}
          >
            <FormattedMessage id={el.id} />
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

export default BasicDataLanguage;